<div *ngIf="containerComponent ">
    <ng-container *ngComponentOutlet="containerComponent"></ng-container>
</div>
